import Text from "@pathwright/ui/src/components/ui/Text"
import View from "@pathwright/ui/src/components/ui/View"
import { WithCSS } from "@pathwright/ui/src/components/utils/styles"
import { css } from "styled-components"

const PathDivider = ({ divider, inverted }) => {
  return (
    <WithCSS
      as={View}
      css={css`
        text-align: center;
        padding: 5px 0;
        user-select: none;
      `}
    >
      <Text.H5 inverted={inverted}>{divider.name}</Text.H5>
    </WithCSS>
  )
}

PathDivider.displayName = "PathDivider"

export default PathDivider
